export default __webpack_public_path__ + "static/media/SS3Semibold.otf.17c42b15.woff";